import React, { FunctionComponent } from 'react';
import ModalWrapper from './ModalWrapper'

interface ConfirmModalProps {
    isModalOpen: boolean
    modalConfig: ModalConfig
    hideConfirm?: boolean
    hideCancel? : boolean
    setModalOpen: (val: boolean) => void
    onConfirm: (...args: any) => void
    onCancel: (...args: any) => void
    children: JSX.Element | JSX.Element[] | string
}

export interface ModalConfig {
    confirmText?: string
    cancelText?: string
    color?: "primary" | "warning",
}

const ConfirmModal = ({
    isModalOpen,
    modalConfig,
    hideConfirm=false,
    hideCancel=false,
    setModalOpen,
    onConfirm,
    onCancel,
    children
}: ConfirmModalProps) => {
    const { confirmText, cancelText="No, cancel", color="primary"} = modalConfig;
    
    return (
        <ModalWrapper isOpen={isModalOpen} onRequestClose={setModalOpen} className='confirm-modal'>
            <div className='body-text'>{children}</div>
            {!hideConfirm && <button className={`modal-button pill ${color}`} onClick={onConfirm}>{confirmText}</button>}
            {!hideCancel && <button className={`modal-button link`} onClick={onCancel}>{cancelText}</button>}
        </ModalWrapper>
)}

export default ConfirmModal